import React from "react"
import TermTitle from "./term_title"
import TermDescription from "./term_description"

const FullscreenTermInfo = ({
  name,
  alt_name,
  audio_url,
  alt_audio_url,
  can_play,
  synonyms
}) => (
  <div className="fullscreen-info">
    <TermTitle
      name={name}
      alt_name={alt_name}
      audio_url={audio_url}
      alt_audio_url={alt_audio_url}
      can_play={can_play}
    />
    {!!synonyms?.length &&
      <TermDescription synonyms={synonyms} show_all_synonyms={true}/>}
  </div>
)

export default FullscreenTermInfo
